const currencyFormatter = (
  amount: number | string,
  withSymbol: boolean = false,
  symbolPosition: 'before' | 'after' = 'before'
): string => {
  let temp = amount;
  try {
    if (temp) {
      if (typeof temp === 'string') {
        temp = temp.replace(/,/g, '.');
      }

      let value = Number(temp).toLocaleString('de-DE', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });

      // Exception for 0
      if (value === '0,00' || value === '0.0') {
        value = '0';
      }

      if (withSymbol && symbolPosition === 'before') {
        return '€ ' + value;
      } else if (withSymbol && symbolPosition === 'after') {
        return value + ' €';
      } else {
        return value;
      }
    } else {
      if (withSymbol && symbolPosition === 'before') {
        return '€ 0';
      } else if (withSymbol && symbolPosition === 'after') {
        return '0 €';
      } else {
        return '0';
      }
    }
  } catch (_error) {
    console.error('The wrong number format was used to create the currency string.');
    if (withSymbol) {
      return '€ 0';
    } else {
      return '0';
    }
  }
};

export { currencyFormatter };
